var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_485)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_133_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9185 51.2626L20.7349 51.7528C24.1636 53.8156 28.095 54.9067 32.1041 54.9086H32.1125C44.4244 54.9086 54.4443 44.7538 54.4495 32.2727C54.4516 26.2245 52.1304 20.5369 47.9131 16.2585C45.8446 14.1486 43.3838 12.4755 40.6731 11.336C37.9624 10.1966 35.0557 9.61352 32.1213 9.62051C19.7998 9.62051 9.77956 19.7742 9.77518 32.2545C9.76911 36.5162 10.953 40.6927 13.19 44.301L13.7215 45.157L11.4645 53.5094L19.9185 51.2626ZM5.01178 59.98L8.82476 45.8679C6.4732 41.738 5.23605 37.0527 5.23751 32.2527C5.24372 17.2364 17.2989 5.02002 32.1129 5.02002C39.3016 5.02372 46.0491 7.85955 51.1237 13.0073C56.1983 18.155 58.9904 24.9974 58.9879 32.2745C58.9813 47.2897 46.9243 59.5083 32.1125 59.5083H32.1008C27.6033 59.5065 23.184 58.3627 19.2585 56.193L5.01178 59.98Z",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.73602 59.7002L8.54901 45.5881C6.19339 41.4483 4.95607 36.7521 4.96176 31.9729C4.96797 16.9566 17.0231 4.74023 31.8371 4.74023C39.0259 4.74394 45.7734 7.57976 50.848 12.7275C55.9226 17.8752 58.7147 24.7176 58.7121 31.9948C58.7055 47.0099 46.6485 59.2285 31.8367 59.2285H31.8251C27.3276 59.2267 22.9082 58.0829 18.9828 55.9132L4.73602 59.7002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8451 9.3404C19.5237 9.3404 9.50343 19.4941 9.49905 31.9744C9.49298 36.2361 10.6769 40.4125 12.9139 44.0209L13.4454 44.8773L11.1884 53.2296L19.6428 50.9825L20.4591 51.4727C23.8879 53.5354 27.8192 54.6262 31.8283 54.6285H31.8367C44.1487 54.6285 54.1689 44.4737 54.1737 31.9926C54.183 29.0177 53.6101 26.0706 52.4881 23.3217C51.3661 20.5729 49.7174 18.077 47.6373 15.9784C45.5688 13.8684 43.1079 12.1953 40.3972 11.0558C37.6864 9.91642 34.7797 9.33335 31.8451 9.3404Z",
    fill: "url(#paint0_linear_133_485)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1199 20.5874C24.6166 19.454 24.0869 19.4311 23.6088 19.4114L22.3216 19.3955C21.8738 19.3955 21.1462 19.5658 20.5311 20.2471C19.916 20.9284 18.1806 22.5749 18.1806 25.9239C18.1806 29.273 20.587 32.509 20.9223 32.9637C21.2576 33.4184 25.5677 40.51 32.3934 43.2384C38.0656 45.5059 39.2198 45.0549 40.4515 44.9416C41.6831 44.8283 44.4244 43.2951 44.9837 41.7056C45.5429 40.116 45.5432 38.7542 45.3756 38.4695C45.2079 38.1848 44.7601 38.0155 44.088 37.6749C43.416 37.3343 40.1151 35.6877 39.4996 35.4604C38.8841 35.233 38.4367 35.1201 37.9885 35.8014C37.5403 36.4827 36.255 38.0152 35.863 38.4695C35.4711 38.9238 35.0799 38.9808 34.4078 38.6405C33.7357 38.3003 31.5734 37.5812 29.0078 35.2623C27.0116 33.458 25.6642 31.2298 25.2719 30.5489C24.8796 29.868 25.2302 29.4992 25.567 29.16C25.8683 28.8549 26.2383 28.3651 26.5748 27.9678C26.9112 27.5705 27.0218 27.2865 27.2454 26.8329C27.4689 26.3794 27.3575 25.981 27.1895 25.6407C27.0215 25.3004 25.7168 21.9336 25.1199 20.5874Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_133_485",
    x: -2.05022,
    y: -2.04198,
    width: 68.1001,
    height: 69.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.531,
    result: "effect1_foregroundBlur_133_485"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_485",
    x1: 31.3816,
    y1: 12.0581,
    x2: 31.6143,
    y2: 50.7596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.53f30d0b754f4930df18a853ad57ab9a.svg";
export { ForwardRef as ReactComponent };